module.exports = __webpack_public_path__ + "static/media/mapp-review-disabled-star.8ed9c1f8.svg";